/**
 * VUE SETUP
 */

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)
/**************
 * COMPONENTS *
 **************/
// Vue.component('icon', require('@/components/shared/ui/icon.vue'))
Vue.component('modal', require('@/components/shared/ui/modal.vue'))
import bindDispatcher from '@/components/shared/system/bind-dispatcher.vue'
Vue.component('bindDispatcher', bindDispatcher)

// Vue.component('swapper', require('components/shared/ui/swapper.vue'))

/**************
 * DIRECTIVES *
 **************/

/***********
 * FILTERS *
 ***********/

/***********
 * TRANSITIONS *
 ***********/

const isDev = process.env.NODE_ENV !== 'production'
if (isDev) {
  Vue.config.debug = true
}

Vue.prototype.$img = function (img) {
  return `${isDev ? '/' : './'}${img}`
}



// WEBPACK FOOTER //
// ./src/setup/vue.js